/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Breakdown/view.blocks to change it.
import Conversions from './Conversions/index'
import LeadsCreated from './LeadsCreated/index'
import LeadsIncomplete from './LeadsIncomplete/index'
import Paying from './Paying/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Breakdown({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Pie/CampaignOverview/Breakdown"
  
}) {
  return (<React.Fragment
>
<Conversions
  viewPath={`${viewPath}/Conversions`}
/>
<Paying
  viewPath={`${viewPath}/Paying`}
/>
<LeadsIncomplete
  viewPath={`${viewPath}/LeadsIncomplete`}
/>
<LeadsCreated
  viewPath={`${viewPath}/LeadsCreated`}
/>
{children}
</React.Fragment>)
}